import styled, { css } from 'styled-components';
import { maxWidth } from '@/assets/styles/mixins.css.js';
import vars from '@/assets/styles/vars';

const Title = styled.h2`
  font-weight: 400;
  line-height: 1.225;
  letter-spacing: -0.01em;
  color: var(--color-decor);

  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}

  ${(props) =>
    props.tabletLeft &&
    css`
      ${maxWidth(vars.breakpoints.tablet)`
      text-align: left;
      `}
    `}

  ${(props) =>
    props.upper &&
    css`
      text-transform: uppercase;
    `}

    ${(props) =>
    props.black &&
    css`
      color: #323232;
    `}

  ${({ size }) => {
    switch (size) {
      case 'x-large':
        return css`
          font-size: 48px;

          ${maxWidth(vars.breakpoints.tablet)`
            font-size: 36px;
          `}
        `;
      case 'large':
        return css`
          font-size: 40px;
          ${maxWidth(vars.breakpoints.tablet)`
            font-size: 34px;
          `}
        `;
      case 'small':
        return css`
          font-size: 34px;
          ${maxWidth(vars.breakpoints.tablet)`
            font-size: 28px;
          `}
        `;
      case 'medium':
      default:
        return css`
          font-size: 38px;

          ${maxWidth(vars.breakpoints.tablet)`
            font-size: 34px;
          `}
        `;
    }
  }}

  ${({ mb }) => {
    switch (mb) {
      case 'none':
        return css`
          margin-bottom: 0;
        `;
      case 'small':
        return css`
          margin-bottom: 30px;

          ${maxWidth(vars.breakpoints.tablet)`
            margin-bottom: 20px;
          `}
        `;
      case 'x-small':
        return css`
          margin-bottom: 20px;

          ${maxWidth(vars.breakpoints.tablet)`
            margin-bottom: 20px;
          `}
        `;
      case 'medium':
      default:
        return css`
          margin-bottom: 40px;

          ${maxWidth(vars.breakpoints.tablet)`
            margin-bottom: 32px;
          `}

          ${maxWidth(vars.breakpoints.lMobile)`
            margin-bottom: 30px;
          `}
        `;
    }
  }}
`;

export default Title;
